import React from 'react'
import ReportFooter from './Footer'
import ReportHeader from './Header'
import ReportAmount from './ReportAmount'
import ReportDetail from './ReportDetail'
import './index.scss'
import { CContainer } from '@coreui/react'

export class EndowmentReportComponent extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="endowment-report-content">
          <CContainer>
            <ReportHeader />
            <ReportDetail {...this.props} />
            <ReportAmount {...this.props} />
            <ReportFooter />
          </CContainer>
        </div>
      </div>
    )
  }
}

const EndowmentReport = React.forwardRef((props, ref) => {
  return <EndowmentReportComponent {...props} ref={ref} />
})

export default EndowmentReport
